import {
    FaUserEdit,
    FaTruck,
    FaUsers,
    FaDatabase,
    FaCog,
    FaUserAltSlash,
    FaUserCog,
    FaCity,
    FaUserCircle,
    FaCalculator,
    FaCogs,
    FaChartArea,
    FaTimes,
    FaFileUpload,
    FaFileInvoiceDollar,
    FaShoppingCart,
    FaClipboardList,
    FaMoneyBill,
    FaReceipt,
    FaCalendar,
    FaIdCard,
    FaBalanceScale,
    FaFileInvoice,
    FaBox,
    FaFileAlt,
    FaHandshake,
    FaCubes,
    FaRoute,
    FaSnowflake,
    FaChartLine,
    FaShieldAlt,
    FaHistory,
    FaExclamationTriangle,
    FaMoneyCheckAlt,
    FaTasks,
    FaThLarge,
    FaSitemap,
    FaPlusCircle,
    FaUserGraduate,
    FaCalendarAlt,
    FaUserSlash,
    FaUserPlus,
    FaDolly,
    FaBoxOpen,
    FaExternalLinkAlt,
    FaLayerGroup,
    FaGavel,
    FaChartBar,
    FaHeadset,
    FaMobileAlt,
    FaLaptop,
} from "react-icons/fa";
import { LuMonitorCog } from "react-icons/lu";
import { FaMountainCity, FaTruckArrowRight } from "react-icons/fa6";
import { RiDashboard2Fill, RiDashboardFill, RiFlowChart } from "react-icons/ri";
import { GiReceiveMoney } from "react-icons/gi";
import { BsFillWrenchAdjustableCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/authContext.jsx';
import { reduzirNome } from '../../utils/reduzirNome.jsx';

const sair = () => {
    localStorage.clear();
    window.location.href = '/login';
};

/** Menu do aplicativo MyDash (BI original) — Dashboards, BP, Comissões, Cadastros, Config. */
export function NavItemsMydash() {

    const navigate = useNavigate();
    const { user } = useAuth();

    return [
        {
            label: "WorkFlows",
            icon: FaExternalLinkAlt,
            command: () => { window.location.href = "/solicitacoes" }
        },
        {
            label: "Dashboards",
            icon: RiDashboardFill,
            items: [
                {
                    label: "Contabilidade",
                    icon: FaBalanceScale,
                    items: [
                        { label: "Acompanhamento BP", icon: FaChartArea, command: () => navigate("/acompanhamento-bp") },
                        { label: "Conciliação de Saldos", icon: FaBalanceScale, command: () => navigate("/conciliacao-de-saldos") },
                        { label: "Prestação de Contas", icon: FaFileInvoice, command: () => navigate("/prestacao-contas") },
                        { label: "Pagamento de Compensadas", icon: FaMoneyCheckAlt, command: () => navigate("/pagamento-compensadas") },
                    ]
                },
                {
                    label: "Suprimentos",
                    icon: FaShoppingCart,
                    items: [
                        { label: "Solicitação de Compras", icon: FaShoppingCart, command: () => navigate("/solicitacao-de-compras") },
                        { label: "Lançamentos de Despesa", icon: FaReceipt, command: () => navigate("/lancamento-de-despesa") },
                    ]
                },
                {
                    label: "RH",
                    icon: FaUsers,
                    items: [
                        { label: "Eventos de Folhas", icon: FaCalendar, command: () => navigate("/eventos-folhas") },
                        { label: "Funcionários", icon: FaIdCard, command: () => navigate("/motoristas") },
                        { label: "Jornadas Trabalhadas", icon: FaHistory, command: () => navigate("/jornada-trabalhada") },
                    ]
                },
                {
                    label: "Logística",
                    icon: FaTruck,
                    items: [
                        { label: "Montagem de Cargas", icon: FaBox, command: () => navigate("/montagem-de-cargas") },
                        { label: "Relatório de Veículos", icon: FaTruck, command: () => navigate("/frota") },
                        { label: "Notas Fiscais de Veículos", icon: FaFileAlt, command: () => navigate("/notas-veiculos") },
                        { label: "Comissões", icon: FaHandshake, command: () => navigate("/comissoes") },
                        { label: "Volume Entregue", icon: FaCubes, command: () => navigate("/volume-entregue") },
                        { label: "Rotas Finalizadas", icon: FaRoute, command: () => navigate("/rotas-finalizadas") },
                        { label: "Entregas e Retornos", icon: FaChartLine, command: () => navigate("/dashboard-entregas-retornos") },
                        { label: "Segurança Viária", icon: FaShieldAlt, command: () => navigate("/seguranca-viaria") },
                        { label: "Telemetria (Gestão)", icon: FaCogs, command: () => navigate("/telemetria"), roles: ['ADMIN'] },
                        { label: "Infrações Caxias", icon: FaExclamationTriangle, command: () => navigate("/infracoes-motoristas/caxias") }
                    ]
                },
                {
                    label: "T.I",
                    icon: FaLaptop,
                    roles: ['ADMIN'],
                    items: [
                        { label: "Inventário de Ativos", icon: FaLaptop, command: () => navigate("/ti/inventario"), roles: ['ADMIN'] },
                        { label: "Cadastros do Inventário", icon: FaCogs, command: () => navigate("/ti/catalogos"), roles: ['ADMIN'] },
                    ],
                },
            ]
        },
        {
            label: "BP",
            icon: RiDashboard2Fill,
            roles: ['ADMIN', "CONTADOR", 'DIRETOR', 'BP'],
            items: [
                { label: "Acompanhamento BP", icon: FaChartArea, command: () => navigate("/acompanhamento-bp") },
                { label: "Meu BP", icon: FaMoneyBill, command: () => navigate("/bp/2026") },
                { label: "Contas BP", icon: FaCalculator, command: () => navigate("/bp/gerenciamento") },
                {
                    label: "Cadastros",
                    icon: FaDatabase,
                    items: [
                        { label: "Centro de Custo", icon: FaFileInvoiceDollar, command: () => navigate("/centro-custo") },
                        { label: "Conta Contábil", icon: FaCalculator, command: () => navigate("/conta-contabil") },
                        { label: "Conta Financeira", icon: FaMoneyCheckAlt, command: () => navigate("/conta-financeira") },
                        { label: "Grupo Contábil", icon: FaCalculator, command: () => navigate("/grupo-contabil") }
                    ]
                },
            ]
        },
        {
            label: "Comissões",
            icon: GiReceiveMoney,
            roles: ['ADMIN', "LOGISTICA", "COMISSOES", "RH"],
            items: [
                { label: "Comissões", icon: GiReceiveMoney, command: () => navigate("/comissoes") },
                { label: "Escalas de Rotas", icon: FaTruckArrowRight, command: () => navigate("/escalas-de-rotas") },
                { label: "Ajustes", icon: BsFillWrenchAdjustableCircleFill, command: () => navigate("/ajustes-comissoes") },
                { label: "Intregrações", icon: FaFileUpload, command: () => navigate("/importacao-arquivos") },
                {
                    label: "Parâmetros",
                    icon: FaUserCog,
                    items: [
                        { label: "Funcionários", icon: FaUserEdit, command: () => navigate("/funcionarios") },
                        { label: "Faltas", icon: FaUserAltSlash, command: () => navigate("/faltas") },
                        { label: "Veículos", icon: FaTruck, command: () => navigate("/veiculos") },
                        { label: "Parâmetros", icon: FaCog, command: () => navigate("/parametros-comissoes") }
                    ]
                },
            ]
        },
        {
            label: "Cadastros",
            icon: FaDatabase,
            roles: ['ADMIN'],
            items: [
                { label: "Filiais", icon: FaCalculator, command: () => navigate("/filiais"), roles: ['ADMIN'] },
                { label: "Estados", icon: FaMountainCity, command: () => navigate("/estados") },
                { label: "Cidades", icon: FaCity, command: () => navigate("/cidades") },
                { label: "Usuários do Sistema", icon: FaUsers, command: () => navigate("/usuarios") },
                { label: "Grupos de Usuários", icon: FaUsers, command: () => navigate("/grupos-usuarios") },
            ],
        },
        {
            label: "Config",
            icon: FaCog,
            roles: ['ADMIN'],
            items: [
                { label: "Config. Geral", icon: FaCogs, command: () => navigate("/configuracoes") },
                { label: "Monitor de Tarefas", icon: LuMonitorCog, command: () => navigate("/monitor-sincronismo") },
            ],
        },
        {
            label: reduzirNome(user.nome) || "Usuário",
            icon: FaUserCircle,
            items: [
                { label: "Meu Usuário", icon: FaUserCircle, command: () => navigate("/meu-usuario") },
                { label: "Alterar Senha", icon: FaUsers, command: () => navigate("/alterar-senha") },
                { label: "Mudar para Workflows", icon: RiFlowChart, command: () => navigate("/solicitacoes/inicio") },
                { label: "Sair", icon: FaTimes, command: () => sair() },
            ],
        }
    ];
}

/** Menu do aplicativo MyDash Solicitações — processos, tarefas, aprovações e seus dashboards. */
export function NavItemsSolicitacoes() {
    const navigate = useNavigate();

    const { user } = useAuth();

    return [
                {
            label: "B.I",
            icon: FaExternalLinkAlt,
            command: () => { window.location.href = "/bi" }
        },
        {
            label: "Solicitações",
            icon: FaSitemap,
            items: [
                { label: "Iniciar Solicitação", icon: FaPlusCircle, command: () => navigate("/solicitacoes/nova") },
                { label: "Central de Tarefas", icon: FaTasks, command: () => navigate("/solicitacoes/central-tarefas") },
                { label: "Todas as Solicitações", icon: FaClipboardList, command: () => navigate("/solicitacoes/todas") },
            ]
        },
        {
            label: "Dashboard",
            icon: FaThLarge,
            items: [
                { label: "Solicitação de Compras", icon: FaShoppingCart, command: () => navigate("/solicitacoes/relatorios/compras") },
                { label: "Lançamento de Despesa", icon: FaFileInvoiceDollar, command: () => navigate("/solicitacoes/relatorios/despesa") },
                { label: "Processo de Multas", icon: FaGavel, command: () => navigate("/solicitacoes/relatorios/multas") },
                { label: "Promoção, Enquadramento e Transferência", icon: FaUserGraduate, command: () => navigate("/solicitacoes/relatorios/promocoes") },
                { label: "Desligamento de Pessoal", icon: FaUserSlash, command: () => navigate("/solicitacoes/relatorios/desligamento") },
                { label: "Solicitação de Pessoal (Funcionário)", icon: FaUserPlus, command: () => navigate("/solicitacoes/relatorios/solicitacao-pessoal") },
                { label: "Abertura de Chamado TI", icon: FaHeadset, command: () => navigate("/solicitacoes/relatorios/chamados-ti") },
                { label: "Recolhimento de Ativos", icon: FaDolly, command: () => navigate("/solicitacoes/relatorios/recolhimento-ativos") },
                { label: "Solicitação de Ativos", icon: FaBoxOpen, command: () => navigate("/solicitacoes/relatorios/solicitacao-ativos") },
                { label: "Análise de Limite e Prazo", icon: FaBalanceScale, command: () => navigate("/solicitacoes/relatorios/analise-limite-prazo") },
                { label: "Cadastro de Cliente", icon: FaIdCard, command: () => navigate("/solicitacoes/relatorios/cadastro-cliente") },
                { label: "Ajuste de GTC / Visita / Rota", icon: FaRoute, command: () => navigate("/solicitacoes/relatorios/ajuste-gtc") },
                { label: "Renovação de GDM", icon: FaSnowflake, command: () => navigate("/solicitacoes/relatorios/renovacao-gdm") },
                { label: "Conclusão da Renovação de GDM", icon: FaChartBar, command: () => navigate("/solicitacoes/relatorios/conclusao-gdm") },
            ]
        },
        {
            label: "Agenda",
            icon: FaCalendarAlt,
            command: () => navigate("/solicitacoes/despesas-recorrentes")
        },
        {
            label: "Cadastros",
            icon: FaDatabase,
            roles: ['ADMIN', 'SUPRIMENTOS'],
            items: [
                { label: "Fornecedores", icon: FaCalculator, command: () => navigate("/solicitacoes/fornecedores"), roles: ['ADMIN'] },
                { label: "Tipo de Fornecedor", icon: FaCalculator, command: () => navigate("/solicitacoes/tipo-fornecedores"), roles: ['ADMIN'] },
                { label: "Tipo de Pagamento", icon: FaMoneyCheckAlt, command: () => navigate("/solicitacoes/tipo-pagamentos") },
                { label: "Tipos de Produto", icon: FaBox, command: () => navigate("/solicitacoes/config/tipos-produto") },
                { label: "Produtos", icon: FaBox, command: () => navigate("/solicitacoes/config/produtos") },
                { label: "SubCanais", icon: FaLayerGroup, command: () => navigate("/solicitacoes/config/subcanais") },
                { label: "Base de GDM", icon: FaSnowflake, command: () => navigate("/solicitacoes/base-gdm") },
            ],
        },
        {
            label: "Configurações",
            icon: FaCog,
            roles: ['ADMIN'],
            items: [

                { label: "Filiais", icon: FaCalculator, command: () => navigate("/filiais"), roles: ['ADMIN'] },
                { label: "Estados", icon: FaMountainCity, command: () => navigate("/estados") },
                { label: "Cidades", icon: FaCity, command: () => navigate("/cidades") },
                { label: "Usuários do Sistema", icon: FaUsers, command: () => navigate("/solicitacoes/usuarios") },
                { label: "Grupos de Usuários", icon: FaUsers, command: () => navigate("/solicitacoes/grupos-usuarios") },
                { label: "Configuração de Atribuições", icon: FaCogs, command: () => navigate("/solicitacoes/config/atribuicoes") },
                { label: "Gerenciar Solicitações", icon: FaCogs, command: () => navigate("/solicitacoes/config/gerenciar") },
                { label: "Tipos de Serviço de TI", icon: FaHeadset, command: () => navigate("/solicitacoes/config/tipos-servico-ti") },
                { label: "Versões do App", icon: FaMobileAlt, command: () => navigate("/solicitacoes/config/versoes-app") },
            ],
        },
        {
            label: reduzirNome(user.nome) || "Usuário",
            icon: FaUserCircle,
            items: [
                { label: "Meu Usuário", icon: FaUserCircle, command: () => navigate("/solicitacoes/meu-usuario") },
                { label: "Alterar Senha", icon: FaUsers, command: () => navigate("/solicitacoes/alterar-senha") },
                { label: "Mudar para BI", icon: FaChartLine, command: () => navigate("/bi") },
                { label: "Sair", icon: FaTimes, command: () => sair() },
            ],
        }
    ];
}
